import { utils, config } from "../../../../studentportal-sdk";



export const addUser = async(formdata) => {
  try{
      const {data} = await utils.apiConnect().post(config.domains.endpoints.postUserApi, formdata)

      return {
          status: true,
          data: data.data,
          message: data.message
      }
  }catch(error){
      return {
          status: false,
          message: error?.response?.data?.message || error.message,
          error: true
      }
  }
}

export const updateUser = async(formdata) => {
  try{
      const {data} = await utils.apiConnect().put(config.domains.endpoints.updateUserApi, formdata)

      return {
          status: true,
          data: data.data,
          message: data.message
      }
  }catch(error){
      return {
          status: false,
          message: error?.response?.data?.message || error.message,
          error: true
      }
  }
}
/**
 * filter or search users
 */
export const filterUsers = async ({ q }) => {
  try {
    let queryParams = "";
    q && (queryParams = `${queryParams}q=${q}&`);
    queryParams = `${queryParams}page=1&pageSize=50`;

    const { data} = await utils
      .apiConnect()
      .get(`${config.domains.endpoints.getFilterUsersApi}?${queryParams}`);
    return {
      status: true,
      data: data.data,
      message: "",
    };
  } catch (error) {
    return {
      status: false,
      message: error?.response?.data?.message || error.message,
      error: true,
    };
  }
};

export const createUser = async ({
  firstname,
  lastname,
  email,
  gender,
  group,
  category,
  isBaptised,
  dateofbirth,
  phone,
  address,
  password,
  confirmPassword,
  role,
}) => {
  try {
    const { data } = await utils
      .apiConnect()
      .post(config.domains.endpoints.postUserApi, {
        firstname,
        lastname,
        email,
        gender,
        group,
        category,
        isBaptised,
        dateofbirth,
        phone,
        address,
        password,
        confirmPassword,
        role,
      });

    return {
      status: true,
      data: data.data,
      message: "User created successfully.",
    };
  } catch (error) {
    // message.error(error?.response?.data?.message || "Failed to create user.");
    return {
      status: false,
      message: error?.response?.data?.message || error.message,
      error: true,
    };
  }
};

export const fetchAllUsers = async () => {
  try {
    const { data } = await utils
      .apiConnect()
      .get(config.domains.endpoints.getUsersApi);
    return {
      status: true,
      data: data.data,
      message: "Users fetched successfully.",
    };
  } catch (error) {
    // message.error(error?.response?.data?.message || "Failed to fetch users.");
    return {
      status: false,
      message: error?.response?.data?.message || error.message,
      error: true,
    };
  }
};

export const fetchUser = async (userId) => {
  try {
    const { data } = await utils
      .apiConnect()
      .get(config.domains.endpoints.getUsersApi+`/${userId}`);
    return {
      status: true,
      data: data.data,
      message: "Users fetched successfully.",
    };
  } catch (error) {
    // message.error(error?.response?.data?.message || "Failed to fetch users.");
    return {
      status: false,
      message: error?.response?.data?.message || error.message,
      error: true,
    };
  }
};
